/**
 * This directive is intended to inject css variables inline.
 * [ngStyle] directive don't do that, see issue https://github.com/angular/angular/issues/9343
 */

import {
  Directive,
  DoCheck,
  ElementRef,
  Input,
  KeyValueChanges,
  KeyValueDiffer,
  KeyValueDiffers,
} from '@angular/core';

@Directive({ selector: '[trSafeCss]' })
export class SafeCssDirective implements DoCheck {
  private _cssVariables: { [key: string]: string } | null = null;
  private _differ: KeyValueDiffer<string, string | number> | null = null;

  constructor(
    private _ngEl: ElementRef<HTMLElement> | null,
    private _differs: KeyValueDiffers
  ) {}

  @Input('trSafeCss')
  set cssVariables(values: { [varName: string]: string } | null) {
    this._cssVariables = values;
    if (!this._differ && values) {
      this._differ = this._differs.find(values).create();
    }
  }

  ngDoCheck() {
    if (this._differ) {
      const changes = this._differ.diff(this._cssVariables);
      if (changes) {
        this._applyChanges(changes);
      }
    }
  }

  private _variables(name: string, value: string | number | null | undefined): void {
    if (value != null) {
      this._ngEl.nativeElement?.style.setProperty(name, value.toString());
    } else {
      this._ngEl.nativeElement?.style.removeProperty(name);
    }
  }

  private _applyChanges(changes: KeyValueChanges<string, string | number>): void {
    changes.forEachRemovedItem((record) => this._variables(record.key, null));
    changes.forEachAddedItem((record) =>
      this._variables(record.key, record.currentValue)
    );
    changes.forEachChangedItem((record) =>
      this._variables(record.key, record.currentValue)
    );
  }
}
